import {appRouter} from '@netx/core-next/instance/router';
import type {ReactAction} from '@netx/core/bootstrap';
import {faSearch} from '@fortawesome/pro-solid-svg-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canVisualSearch} from '../enablers';
import {SEARCH_VISUAL_ACTION_LABELS} from '../locales';

export const searchVisualActionAssetIcon = faSearch;

/**
 * Visual search by asset
 * @param params
 * @returns Action
 */
export const searchVisualActionAsset = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'search-visual-asset',
	cb: () => appRouter.navigate(`search/visual/asset/${asset.assetId}`, true),
	enableTest: () => canVisualSearch(asset),
	icon: searchVisualActionAssetIcon,
	get label() {
		return SEARCH_VISUAL_ACTION_LABELS.ASSET;
	},
	...params,
});

export default searchVisualActionAsset;
